module.exports = __webpack_public_path__ + "img/chess7.16a716ca.png";